
import { map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { RestService } from './rest.service';
import { IPlaceOfferUserOutput } from '../models/PlaceOfferUserOutputModel';
import { IPlaceOfferResultOutputModel } from '../models/PlaceOfferResultOutputModel';
import { IPlaceOfferInputModel } from '../models/PlaceOfferInputModel';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../auth/authentication.service';
import { ResultOutputModel } from '../models/resultOutputModel';
import { Observable } from 'rxjs';
import { SavePropertyInputModel, EditPropertyDeatilsModel, SavePropertyBrokerInputModel, BrokerSelecttionModel, DocumentCategoryModel, PropertyLeasingHistoryInputModel, PropertySalesInputModel, ImageDetailModel } from '../models/SavePropertyInputModel';
import { IAddToFavorites } from '../models/AddToFavoriteInputModel';
import { AddTo1031Exchange } from '../models/AddTo1031ExchangeModel';
import { AddToSharedListing } from '../models/AddToSharedListingModel';
import { IExpiryDateModel } from '../models/ExpiryDateModel';
import { IPropertyDocAccesChk } from '../models/PropertyDocAccesChk';
import { IPropertDocModel } from '../models/PropertyDocModel';
import { PropertyRevisionModel } from '../models/IPropertyRevisionModel';
import { IResponseModel } from '../models/ResponseModel';
import { DOCUMENT } from '@angular/common';
import { ISharedProperty } from '../models/SharedPropertyInputModel';
import { IRequestDemo } from '../models/RequestDemo';
import { IHourModel } from '../../data-entry-dashboard/data-entry-dashboard/data-entry-dashboard.component';
import { IDueDiligenceUserListModel } from '../models/DueDiligenceUserListModel';
import { IAddStandardUserPropertiesModel } from '../models/AddStandardUserPropertiesModel';
import { SavePropertyContactUserInput } from '../models/SavePropertyContactUserInput';

@Injectable({
  providedIn: 'root'
})
export class PropertyManagementService extends RestService {
  placeOfferResponse = {} as IPlaceOfferUserOutput;
  placeOfferResponseModel = {} as IPlaceOfferResultOutputModel;
  placeOfferInputModel = {} as IPlaceOfferInputModel;
  constructor(protected http: HttpClient, private Authentication: AuthenticationService, @Inject(DOCUMENT) private doc) {
    super(http);
  }

  /**
   * Creates or updates a property
   * @param property The property information information
   */
  saveProperty(property: SavePropertyInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('property/saveproperty', property);
  }
  createLinkForCanonicalURL(url) {
    let link: HTMLLinkElement = this.doc.createElement('link');
    link.setAttribute('rel', 'canonical');
    this.doc.head.appendChild(link);
    link.setAttribute('href', url);
  }
  /**
  * Creates or updates a dataentry property
  * @param property The property information information
  */
  saveDataEntryProperty(property: SavePropertyInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('dataentryproperty/saveDataEntryProperty', property);
  }
  SavePortfolioProperty(property: SavePropertyInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('dataentryproperty/SavePortfolioProperty', property);
  }

  SavePrincipalProperty(property: SavePropertyInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('dataentryproperty/SavePrincipalProperty', property);
  }

  /**
  * Gets all Mooody's rating list
  */
  getSAndPRatingList() {
    return this.GET('property/spratings');
  }

  /**
  * Gets all Mooody's rating list
  */
  getMoodysRatingList() {
    return this.GET('property/moodysratings');
  }

  /**
  * Gets the document categories
  */
  getDocumentCategories() {
    return this.GET('property/doccategories');
  }

  getFileCategories(pageid: number) {
    return this.GET('property/filecategories/' + pageid);
  }

  /**
  * Gets all Fitch rating list
  */
  getFitchRatingList() {
    return this.GET('property/fitchratings');
  }

  /**
   * Gets the subcategory items of the specified property type
   * @param propertyType Property type Id
   */
  getSubCategoriesList(propertyType: number) {
    return this.GET('property/subcategories/' + propertyType);
  }

  /**
   * Gets the property remarks
   */
  getPropertyRemarks() {
    return this.GET('property/propertyRemarks');
  }
  /**
   * Get the list of properties
   */
  getUserDetails() {
    // tslint:disable-next-line:no-debugger

    const url = 'property/placeofferuserdetail/';
    return this.postForEntityObject<IPlaceOfferUserOutput>(url, '').pipe(
      map(response => {
        this.placeOfferResponse = response;
        return this.placeOfferResponse;
      }));
  }

  updateUser(iPlaceOfferUserInput: IPlaceOfferInputModel) {

    const url = 'property/placeOffer/';
    return this.postForEntityObject<IPlaceOfferResultOutputModel>(url, iPlaceOfferUserInput).pipe(
      map(response => {
        this.placeOfferResponseModel = response;
        return this.placeOfferResponseModel;
      }));
  }

  saveInquiry(iPlaceOfferUserInput: IPlaceOfferInputModel) {

    const url = 'opportunity/inquiry/';
    return this.postForEntityObject<IPlaceOfferResultOutputModel>(url, iPlaceOfferUserInput).pipe(
      map(response => {
        this.placeOfferResponseModel = response;
        return this.placeOfferResponseModel;
      }));
  }

  addToFavorite(addToFavorites: IAddToFavorites) {
    return this.postForEntityObject('property/addtofavourites', addToFavorites).pipe(map(response => {
      return response;
    }));
  }

  getPortfolioImages(portfolioId: number) {
    return this.GET('property/GetPortfolioPropertyImages/' + portfolioId);

    //return this.post<any>('property/portfolioPropertyImages', portfolioId);
  }

  addTo1031Exchange(addTo1031Exchange: AddTo1031Exchange) {
    return this.postForEntityObject('property/addTo1031Exchange', addTo1031Exchange).pipe(map(response => {
      return response;
    }));
  }

  addToSharedListing(addToSharedListing: AddToSharedListing) {
    return this.postForEntityObject('property/addToSharedListing', addToSharedListing).pipe(map(response => {
      return response;
    }));
  }
  addToDisliked(addToDisliked: IAddToFavorites) {
    return this.postForEntityObject('property/addtodisliked', addToDisliked).pipe(map(response => {
      return response;
    }));
  }

  get1031PropertiesToSuggest() {
    return this.GET('property/Get1031PropertiesToSuggest');
  }

  getTenants() {
    return this.GET('property/tenants');
  }

  getPropertyDetails(id: string): Observable<EditPropertyDeatilsModel> {
    return this.get<EditPropertyDeatilsModel>('property/edit/' + id);
  }

  getDataEntryPropertyDetails(id: string): Observable<EditPropertyDeatilsModel> {
    return this.get<EditPropertyDeatilsModel>('dataentryproperty/edit/' + id);
  }

  getBrokerLicenses(userId: number): Observable<SavePropertyBrokerInputModel[]> {
    return this.get<SavePropertyBrokerInputModel[]>('property/brokerlicenses/' + userId);
  }

  getBrokers(stateId: number): Observable<BrokerSelecttionModel[]> {
    return this.get<BrokerSelecttionModel[]>('property/brokers/' + stateId);
  }

  getBrokersForOffers(stateId: number): Observable<BrokerSelecttionModel[]> {
    return this.get<BrokerSelecttionModel[]>('property/brokersForOffer/' + stateId);
  }

  getPrincipalPortfolioProperties(userId: number, userGuid: string, principalid: string) {
    return this.GET('property/getPrincipalPortfolioProperties/' + userId + '/' + userGuid + '/' + principalid);
  }
  getDataEntryStaffs(): Observable<BrokerSelecttionModel[]> {
    return this.get<BrokerSelecttionModel[]>('property/dataEntryStaffs/');
  }

  getPropertyDocuments(propertyId) {
    return this.GET('property/documents/' + propertyId);
  }

  checkDDApproval(propertyId) {
    return this.GET('property/DDApproval/' + propertyId);
  }

  checkOMApproval(propertyId) {
    return this.GET('property/OMApproval/' + propertyId);
  }

  checkCAApproval(propertyId,typeId) {
    return this.GET('property/CAApproval/' + propertyId + '/' + typeId);
  }


  savePropertyContactForDeleteUser(input: SavePropertyContactUserInput): Observable<boolean> {
    return this.postForEntityObject('property/savePropertyContactForDeleteUser/', input);
  }

  deleteImage(id: number) {
    return this.post('property/deleteImage/' + id, '');
  }
  deleteMultipleImage(ids: number[], userId: number) {
    return this.postForEntityObject('property/deleteMultipleImage/' + userId, ids);
  }
  deleteInquiry(id: number) {
    return this.post('property/deleteInquiry/' + id, '');
  }
  deleteDocument(id: number, userId: number) {
    return this.post('property/deleteDocument/' + id + "/" + userId, '');
  }
  deleteMultipleDocument(ids: number[], userId: number) {
    return this.postForEntityObject('property/DeleteMultipleDocument/' + userId, ids);
  }
  deletePropertyDocument(docid: number, userId: number, propertyid: number) {
    return this.post('property/DeletePropertyDocument/' + docid + "/" + userId + "/" + propertyid, '');
  }
  deleteMyPortfolioDocument(docid: number, userId: number) {
    return this.post('property/DeleteMyPortfolioDocument/' + docid + "/" + userId, '');
  }
  deleteOffers(id: number, loggedinUserId: number) {
    return this.post('property/deleteOffers/' + id + "/" + loggedinUserId, '');
  }
  revokeDuediligenceAccess(userId: number, propertyId: number, loggedinuserId: number) {
    return this.post('property/revokeDuediligenceAccess/' + userId + "/" + propertyId + "/" + loggedinuserId, '');
  }
  revokeOMAccess(userId: number, propertyId: number, loggedinuserId: number) {
    return this.post('property/revokeOMAccess/' + userId + "/" + propertyId + "/" + loggedinuserId, '');
  }
  saveDueDiligenceApproval(id: number, ddaccessValue: boolean) {
    return this.post('property/saveDueDiligenceApproval/' + id + "/" + ddaccessValue, '');
  }
  saveOMAPproval(id: number, ddaccessValue: boolean) {
    return this.post('property/saveOMApproval/' + id + "/" + ddaccessValue, '');
  }
  saveCAAPproval(id: number, ddaccessValue: boolean, typeId: number) {
    return this.post('property/saveCAApproval/' + id + "/" + ddaccessValue + "/" + typeId, '');
  }
  /**
 * Change the Inquiry Status
 */
  changeInquiryStatus(statusId: number, inquiryId: number) {
    return this.post('opportunity/changeInquiryStatus/' + statusId + '/' + inquiryId, '');
  }
  DeleteSharedProperty(sharedListingId: number, propertyId: number) {
    return this.post('property/deletesharedproperty/' + sharedListingId + '/' + propertyId, '');
  }

  SetExpiryDate(expiryDateModel: IExpiryDateModel) {

    return this.postForEntityObject('property/setExpiryDate/', expiryDateModel);

  }
  ResumeExpiryDate(guidVal: string) {
    return this.post('property/resumeExpiryDate/' + guidVal, '');
  }

  SetAsExpired(guidVal: string) {
    return this.post('property/setAsExpired/' + guidVal, '');
  }

  changeOfferStatus(statusId: number, leadId: number, userId: number) {
    return this.post('opportunity/changeOfferStatus/' + statusId + '/' + leadId + '/' + userId, '');
  }

  saveOfferingMemorandomToAuditLog(utmData) {
    return this.postForEntityObject('property/saveOfferingMemorandomToAuditLog', utmData);
  }
  saveBOVDownloadToAuditLog(utmData) {
    return this.postForEntityObject('property/saveBOVDownloadToAuditLog', utmData);
  }
  saveDueDiligenceToAuditLog(utmData) {
    return this.postForEntityObject('property/saveDueDiligenceToAuditLog', utmData);
  }

  saveDueDiligenceViewToAuditLog(utmData) {
    return this.postForEntityObject('property/SaveDueDiligenceViewToAuditLog', utmData);
  }
  saveOMViewToAuditLog(utmData) {
    return this.postForEntityObject('property/SaveOMViewToAuditLog', utmData);
  }
  getDocumentCategoryIds(propertyid, isFromPropertyDashboard) {
    return this.GET('property/DocCategoryId/' + propertyid + '/' + isFromPropertyDashboard);
  }
  getDueDiligenceAccessCount(propertyid, source) {
    return this.postForEntityObject<number>('property/GetDueDiligenceAccessCount/' + propertyid + '/' + source, '');
  }

  getDataEntryStaffDocumentCategoryIds(propertyid) {
    return this.GET('dataentryproperty/DocCategoryId/' + propertyid);
  }
  setDefaultImage(id: number) {
    return this.post('property/defaultimage/' + id, '');
  }

  saveDocumentCategory(docList: DocumentCategoryModel[]) {
    return this.postForEntityObject('property/doccategory/', docList);
  }

  saveImageDetail(imageList: ImageDetailModel[]) {
    return this.postForEntityObject('property/imagedetail/', imageList);
  }

  BulkBrokerAssign(BulkBrokerAssignInputModel: any) {
    let user: any = this.Authentication.user;
    BulkBrokerAssignInputModel.ModifiedBy = user.Id
    return this.postForEntityObject('property/BulkBrokerAssign/', BulkBrokerAssignInputModel);
  }

  GetSaleInfoFromOffers(propertyGuid) {
    return this.postForEntityObject('property/GetSaleInfoFromOffers/' + propertyGuid, '');
  }
  getDocumentAccesPendingReqList(iPlaceOfferUserInput: IPropertyDocAccesChk) {
    return this.postForEntityObject<IPropertDocModel>('property/pendingdocAccessReqList', iPlaceOfferUserInput);
  }

  updateStandarduserProperties(addStandardUserProperties: IAddStandardUserPropertiesModel) {
    return this.postForEntityObject('dataentryproperty/updatestandarduserproperties/', addStandardUserProperties);
  }

  GetPropertyAddedByInfo(propId) {
    return this.GET('property/propertyAddedByInfo/' + propId);
  }
  ApproveallDocAccessreq(iPlaceOfferUserInput: IPropertyDocAccesChk) {
    return this.postForEntityObject<IPropertDocModel>('property/ApproveallDocAccessreq', iPlaceOfferUserInput);
  }

  SavePropertyRevision(ipropertyRevison: PropertyRevisionModel) {
    return this.postForEntityObject<number>('property/createpropertyrevision/', ipropertyRevison);
  }

  ShareListing(input) {
    return this.postForEntityObject<IResponseModel>('property/ShareListing', input);
  }

  ShareOMToUsers(input) {
    return this.postForEntityObject<IResponseModel>('property/ShareOM', input);
  }

  AddUserToDD(input) {
    return this.postForEntityObject<IResponseModel>('property/DueDiligence/User', input);
  }

  checkduplicateUserInDocAccessRequest(input) {
    return this.postForEntityObject<boolean>('property/checkDuplicateUserExistInDocRequest', input);
  }

  EditDocAccessRequest(input) {
    return this.postForEntityObject<IResponseModel>('property/UpdateUsersInDocAccess', input);
  }

  GetDueDiiligenceUserList(propertyId, source) {
    return this.GET('property/GetDueDiiligenceUserList/' + propertyId + '/' + source);
  }


  GetGroupsList(userid) {
    return this.GET('property/groupslist/' + userid);
  }

  savepropertyNotes(input) {
    return this.postForEntityObject<IResponseModel>('property/savepropertynote', input);
  }
  GetPropertyNotes(propertyId, fetchCount, userId) {
    return this.GET('property/getpropertynotes/' + propertyId + "/" + fetchCount + "/" + userId);
  }

  GetPropertyRevisionFields(revisionId: number, transactionTypeId: number): Observable<PropertyRevisionModel> {
    return this.get<PropertyRevisionModel>('property/getPropertyRevisionFields/' + revisionId + "/" + transactionTypeId);
  }

  DeleteHistory(revisionId: number) {
    return this.GET('property/deletePropertyRevision/' + revisionId);
  }

  resolveflag(flagId, userId) {
    return this.postForEntityObject('property/resolveflag/' + flagId + "/" + userId, '');
  }

  removenote(noteId) {
    return this.postForEntityObject('property/removenote/' + noteId, '');
  }
  GetFlaggedPropertyCount(userId) {
    return this.GET('property/flaggedPropertyCount/' + userId);
  }
  savePropertyDocAndImages(property: SavePropertyInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('property/savepropertydocandimages', property);
  }

  GetSharedPropertiesUnderGroup(groupId) {
    return this.GET('property/SharedPropertiesUnderGroup/' + groupId);
  }
  savePropertyLeaseHistory(leaseHistory: PropertyLeasingHistoryInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('property/savepropertyLeasingHistory', leaseHistory);
  }

  GetPropertyLeasingHistory(propertyid) {
    return this.GET('property/GetPropertyLeasingHistory/' + propertyid);
  }

  saveDataentrypropertyLeaseHistory(leaseHistory: PropertyLeasingHistoryInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('dataentryproperty/SaveDataEntryPropertyLeasingHistory', leaseHistory);
  }

  GetDataentrypropertyLeasingHistory(propertyid) {
    return this.GET('dataentryproperty/GetDataEntryPropertyLeasingHistory/' + propertyid);
  }

  savePropertySaleHistory(saleHistory: PropertySalesInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('property/savepropertySaleHistory', saleHistory);
  }

  GetPropertySaleHistory(propertyid, transactionTypeId, isDEProperty, propertyTypeId) {
    return this.GET('property/GetPropertySaleHistory/' + propertyid + "/" + transactionTypeId + "/" + isDEProperty + "/" + propertyTypeId);
  }

  saveDataEntryPropertySaleHistory(saleHistory: PropertySalesInputModel): Observable<ResultOutputModel> {
    return this.postForEntityObject<ResultOutputModel>('dataentryproperty/saveDataEntryPropertySaleHistory', saleHistory);
  }

  GetDataEntryPropertySaleHistory(propertyid) {
    return this.GET('dataentryproperty/GetDataEntryPropertySaleHistory/' + propertyid);
  }


  CheckDuplicatePropertyExist(input: any) {
    return this.post('property/CheckDuplicatePropertyExist', input);
  }

  CheckDuplicateSlug(input: any) {
    return this.post('property/CheckDuplicateSlug', input);
  }

  GetPropertyGuid(propertyGuid) {
    return this.GET('dataentryproperty/GetPropertyGuid/' + propertyGuid);
  }

  GetPropertyDetailsForSaleHistory(propertyid) {
    return this.GET('property/GetPropertyDetailsForSaleHistory/' + propertyid);
  }
  GetDataEntryPropertyDetailsForSaleHistory(propertyid) {
    return this.GET('dataentryproperty/GetPropertyDetailsForSaleHistory/' + propertyid);
  }
  GetOfferDetailsByPropertyId(propertyid) {
    return this.GET('property/GetOfferDetailsByPropertyId/' + propertyid);
  }

  GetDuplicatePropertyList(input) {
    return this.post('property/GetDuplicatePropertyList', input);
  }

  ShowHideDD(id: number, status: boolean) {
    return this.post('property/ShowHideDD/' + id + "/" + status, '');
  }

  ModifyAndApproveTenantAndGuarantor(input) {
    return this.post('property/modifyAndApproveTenantAndGuarantor', input);
  }

  copyLink(sharedProperty: ISharedProperty) {
    return this.postForEntityObject('property/CopyLink', sharedProperty).pipe(map(response => {
      return response;
    }));
  }
  GetFeaturedProperties(loggedinuserid) {
    return this.GET('property/FeaturesListing/' + loggedinuserid);
    //// return this.post<IPropertyCard>('property/FeaturesListing/', searchParameters);
  }

  SaveHourlyLimit(hourlyLimitModel: IHourModel) {
    return this.postForEntityObject('property/setExpiryDate/', hourlyLimitModel);
  }

  // GetAddressByAutocomplete(searchText,userId, typeId) {
  //   return this.GET('property/getaddress/' + searchText + '/' + userId + '/' + typeId);
  // }

  GetAddressByAutocomplete(searchText, userId, typeId) {
    return this.GET(
      `property/getaddress?searchText=${searchText}&userId=${userId}&typeId=${typeId}`
    );
  }
  GetAddressByAutocompleteForAdvanceFilter(searchText, userId, typeId) {
    return this.GET(
      `property/GetaddressForAdvanceFilter?searchText=${searchText}&userId=${userId}&typeId=${typeId}`
    );
  }

  GetTenantByAutocompleteForAdvanceFilter(searchText, userId, typeId) {
    return this.GET(
      `property/GetTenantForAdvanceFilter?searchText=${searchText}&userId=${userId}&typeId=${typeId}`
    );
  }

  getOfferDetailsByPropertyId(searchText, userId, typeId) {
    return this.GET(
      `property/getaddress?searchText=${searchText}&userId=${userId}&typeId=${typeId}`
    );
  }

  getTenantList(searchText) {
    return this.GET(`property/Tenants?searchText=${searchText}`);
  }

 
  Getpropertiesfornotification(searchText) {
  return this.GET(`property/GetpropertyNames?searchText=${searchText}`);
   }
 
  getAccountsForAutoComplete(searchText) {
    return this.GET('property/GetAccounts/' + searchText);
  }
}
